const spoxmenLocation: [number, number] = [5.299367, 51.688742];
const enexisLocation: [number, number] = [5.290398385525786, 51.68637947397183];
export { spoxmenLocation, enexisLocation };